<template>
  <v-list-item class="producto-movil" :class="{ 'producto-movil--agregado': flash, 'producto-movil--agotado': agotado }" @click="selectProduct" :disabled="!hasPrice()">
    <v-list-item-avatar tile size="48" color="grey lighten-3" class="rounded">
      <v-img v-if="item.image" height="100%" :src="getPathProduct(item)"></v-img>
      <span v-else class="producto-movil__inicial">{{ (item.name || "?").trim().charAt(0).toUpperCase() }}</span>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="producto-movil__nombre">
        {{ item.name }}
      </v-list-item-title>
      <v-list-item-subtitle class="producto-movil__detalle">
        <span class="producto-movil__precio">{{ $filters.currency($pos.getSalePrice(this.item, 0, getPriceListId()), 0) }}</span>
        <v-chip x-small color="red darken-1" dark class="ml-2" v-if="agotado">Agotado</v-chip>
      </v-list-item-subtitle>
      <div v-if="principioActivo" class="producto-movil__principio"><v-icon x-small color="teal darken-2">mdi-flask-outline</v-icon> {{ principioActivo }}</div>
      <div v-else-if="item.description && item.description.trim()" class="producto-movil__descripcion">{{ item.description }}</div>
      <div v-if="enOrden() > 0" class="producto-movil__enorden">
        <v-icon x-small color="inherit" class="mr-1">mdi-check-circle</v-icon>{{ enOrden() }} en {{ palabra }}
      </div>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn fab small depressed :color="flash ? '#2e7d5b' : 'primary'" aria-label="Agregar">
        <v-icon>{{ flash ? "mdi-check" : "mdi-plus" }}</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
import { esAgotado } from "@/plugins/pos/agotados";

export default {
  name: 'ProductCardMobile',
  components: {  },
    data: () => ({
      prices: null,
      flash: false,
      cantidadVista: 0,
      palabra: "la orden",
      temporizador: null,
  		//isVisible: false
    }),
    props: ['item', 'priceList'],
    computed: {
      // En una droguería, lo que lleva el medicamento: el cliente suele preguntar por eso.
      principioActivo() {
        const m = this.$store.getters.isDrugStore && this.item.info_medication;
        return (m && m.active_ingredient) || "";
      },
      agotado() {
        return esAgotado(this.item.id);
      },
    },
   /* mounted(){
    },	*/
    mounted(){
      // En la app de meseros se dice «pedido»; en la caja, «orden».
      if (this.$el.closest && this.$el.closest(".app-meseros")) {
        this.palabra = "el pedido";
      }
      this.cantidadVista = this.enOrden();
    },
    // Cuando la cantidad de este producto en la orden sube (por el + o por la ventana de opciones),
    // la fila se marca un momento para que se note que sí se agregó.
    updated(){
      const n = this.enOrden();
      if (n > this.cantidadVista) {
        this.flash = true;
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(() => { this.flash = false; }, 1000);
        if (navigator.vibrate) {
          navigator.vibrate(25);
        }
      }
      this.cantidadVista = n;
    },
    beforeDestroy(){
      clearTimeout(this.temporizador);
    },
    methods:{
      // Cuántas unidades de este producto lleva la orden actual (la lee de nuevo cuando la orden cambia).
      enOrden(){
        void this.$store.getters.orderChanged;
        const orden = this.$pos.getCurrentOrder();
        let total = 0;
        for (const linea of (orden && orden.data_items) || []) {
          if (linea.product && linea.product.id === this.item.id) {
            total += parseFloat(linea.quantity) || 0;
          }
        }
        return total;
      },
      selectProduct(){
        if(this.hasPrice()){
          this.$emit('select:product', this.item)
        }
      },
      hasPrice(){
        return this.$pos.getSalePrice(this.item, 0, this.getPriceListId()) > 0;
      },
      getPriceListId(){
        if(this.priceList){
          return this.priceList.id
        }
        return null
      },
      getPathProduct(item){
        if(item && this.$store.state.shared && this.$store.state.shared.company){
          //return this.$http.getBaseUrlImagesProducts() + this.$store.state.shared.company.id + '/' + item.image;
          return this.$http.getBaseUrlImagesProducts() + '/' + item.image;
        }
        return '@/assets/product-blank.png';
      },
      /*visibilityChanged(isVisible, entry){
      	this.isVisible = isVisible
      }*/
    }
}
</script>
<style scoped>
.producto-movil {
  min-height: 72px;
  transition: background-color 0.4s;
}

.producto-movil--agotado {
  opacity: 0.55;
}

.producto-movil--agregado {
  background-color: #e3f4ea;
}

.producto-movil__enorden {
  margin-top: 2px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #2e7d5b;
}

/* El nombre completo, en hasta tres líneas: el mesero tiene que ver qué está vendiendo. */
.producto-movil__nombre {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  font-size: 1rem !important;
  font-weight: 600;
  line-height: 1.25 !important;
}

.producto-movil__detalle {
  margin-top: 2px;
  white-space: normal !important;
}

.producto-movil__descripcion {
  margin-top: 1px;
  font-size: 0.78rem;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.55);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.producto-movil__principio {
  margin-top: 1px;
  font-size: 0.8rem;
  line-height: 1.2;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.producto-movil__inicial {
  font-size: 1.3rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);
}

.producto-movil__precio {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--pos-azul-marino);
}
</style>
